// https://github.com/chakra-ui/chakra-ui/issues/457#issuecomment-1079961123
import {
  Input,
  FormControl,
  FormLabel,
  InputGroup,
  InputLeftElement,
  FormErrorMessage,
  Icon,
} from '@chakra-ui/react';
import { FiFile } from 'react-icons/fi';
import { useController } from 'react-hook-form';
import React, { useRef } from 'react';

export const FileUpload = React.forwardRef(({
  name,
  placeholder,
  acceptedFileTypes,
  control,
  children,
  isRequired = false,
  color='black',
  bg='transparent'
},ref) => {
  const inputRef = useRef();
  const {
    field: { ref:fieldRef, onChange, value, ...inputProps },
    fieldState,
    fieldState: { invalid, isTouched, isDirty },
  } = useController({
    name,
    control,
    rules: { required: isRequired },
  });
  
  return (
    <FormControl isInvalid={invalid}>
      {children && <FormLabel htmlFor="writeUpFile">{children}</FormLabel>}
      <InputGroup color={color}>
        <InputLeftElement pointerEvents="none" zIndex={0}>
          <Icon as={FiFile} />
        </InputLeftElement>
        <input
          type="file"
          onChange={e => onChange(e.target.files[0])}
          accept={acceptedFileTypes}
          name={name}
          ref={inputRef}
          {...inputProps}
          // inputRef={ref}
          style={{ display: 'none' }}
        />
        <Input
          placeholder={placeholder || 'Your file ...'}
          onClick={() => inputRef.current.click()}
          // onChange={(e) => {}}
          readOnly={true}
          value={(value && value.name) || ''}
          cursor={'pointer'}
          bg={bg}
          _placeholder={{ color: color }}
        />
      </InputGroup>
      <FormErrorMessage>{'Attachment is required'}</FormErrorMessage>
    </FormControl>
  );
});

FileUpload.defaultProps = {
  acceptedFileTypes: '',
  allowMultipleFiles: false,
};

export default FileUpload;
